import { useSelector } from "react-redux";
import { getAvailableCreditsTotal } from "app/pages/Account/MyCoupons/couponSelector";
import TotalCreditBanner from "app/pages/FicheProduit/components/Credit/TotalCreditBanner";

const TotalCreditBannerContainer = () => {
	const totalCredit = useSelector(getAvailableCreditsTotal);
	return <TotalCreditBanner totalCredit={totalCredit} />;
};

export default TotalCreditBannerContainer;
